export const trimText = (value) => String(value ?? '').trim()

export const lowerText = (value) => trimText(value).toLowerCase()
